import { renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "flex h-full w-full flex-col" };
const _hoisted_2 = ["data-state", "data-collapsible", "data-variant", "data-side"];
const _hoisted_3 = {
    "data-sidebar": "sidebar",
    class: "bg-sidebar group-data-[variant=floating]:border-sidebar-border flex h-full w-full flex-col group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:shadow-sm"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ($props.collapsible === 'none')
        ? (_openBlock(), _createElementBlock("div", _mergeProps({
            key: 0,
            "data-slot": "sidebar",
            class: $setup.cn('bg-sidebar text-sidebar-foreground flex h-full w-(--sidebar-width) flex-col', $setup.props.class)
        }, _ctx.$attrs), [
            _renderSlot(_ctx.$slots, "default")
        ], 16 /* FULL_PROPS */))
        : ($setup.isMobile)
            ? (_openBlock(), _createBlock($setup["Sheet"], _mergeProps({
                key: 1,
                open: $setup.openMobile
            }, _ctx.$attrs, { "onUpdate:open": $setup.setOpenMobile }), {
                default: _withCtx(() => [
                    _createVNode($setup["SheetContent"], {
                        "data-sidebar": "sidebar",
                        "data-slot": "sidebar",
                        "data-mobile": "true",
                        side: $props.side,
                        class: "bg-sidebar text-sidebar-foreground w-(--sidebar-width) p-0 [&>button]:hidden",
                        style: _normalizeStyle({
                            '--sidebar-width': $setup.SIDEBAR_WIDTH_MOBILE,
                        })
                    }, {
                        default: _withCtx(() => [
                            _createVNode($setup["SheetHeader"], { class: "sr-only" }, {
                                default: _withCtx(() => [
                                    _createVNode($setup["SheetTitle"], null, {
                                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                                _createTextVNode("Sidebar", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createVNode($setup["SheetDescription"], null, {
                                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                                _createTextVNode("Displays the mobile sidebar.", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createElementVNode("div", _hoisted_1, [
                                _renderSlot(_ctx.$slots, "default")
                            ])
                        ]),
                        _: 3 /* FORWARDED */
                    }, 8 /* PROPS */, ["side", "style"])
                ]),
                _: 3 /* FORWARDED */
            }, 16 /* FULL_PROPS */, ["open", "onUpdate:open"]))
            : (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "group peer text-sidebar-foreground hidden md:block",
                "data-slot": "sidebar",
                "data-state": $setup.state,
                "data-collapsible": $setup.state === 'collapsed' ? $props.collapsible : '',
                "data-variant": $props.variant,
                "data-side": $props.side
            }, [
                _createCommentVNode(" This is what handles the sidebar gap on desktop  "),
                _createElementVNode("div", {
                    class: _normalizeClass($setup.cn('relative w-(--sidebar-width) bg-transparent transition-[width] duration-200 ease-linear', 'group-data-[collapsible=offcanvas]:w-0', 'group-data-[side=right]:rotate-180', $props.variant === 'floating' || $props.variant === 'inset'
                        ? 'group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4)))]'
                        : 'group-data-[collapsible=icon]:w-(--sidebar-width-icon)'))
                }, null, 2 /* CLASS */),
                _createElementVNode("div", _mergeProps({
                    class: $setup.cn('fixed inset-y-0 z-10 hidden h-svh w-(--sidebar-width) transition-[left,right,width] duration-200 ease-linear md:flex', $props.side === 'left'
                        ? 'left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]'
                        : 'right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]', 
                    // Adjust the padding for floating and inset variants.
                    $props.variant === 'floating' || $props.variant === 'inset'
                        ? 'p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4))+2px)]'
                        : 'group-data-[collapsible=icon]:w-(--sidebar-width-icon) group-data-[side=left]:border-r group-data-[side=right]:border-l', $setup.props.class)
                }, _ctx.$attrs), [
                    _createElementVNode("div", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ], 16 /* FULL_PROPS */)
            ], 8 /* PROPS */, _hoisted_2));
}
